import { Box, Button, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, LinearProgress, Skeleton, Theme, Typography, useTheme } from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory, useRouteMatch } from 'react-router-dom';
import * as yup from 'yup';
import { Form, Formik, FormikProps, setNestedObjectValues } from "../../lib/formik/Formik";
import { useDispatch, useSelector } from 'react-redux';
import {
  sendOtp,
  verifyPan,
  EnablePOA,
  IsApplicableForPOA,
  SendEmail,
  AcknowledgeAmlCheck,
  sendConsentEmail,
  getApplicationTypes,
  physicalOnboarding,
  MfuKycOnboarding,
} from '../../redux-store/actions/onBoarding';
import {
  AcknowledgeAmlCheckResponseBody,
  AmlSystemMatch,
  ApplicationProps,
  CreateApplicationProps,
  EnablePOAResponseBody,
  IsApplicableForPOAResponseBody,
  MfuKycOnboardingResponseBody,
  SendConsentEmailResponseBody,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
  VerifyPanResponseBody,
} from '../../redux-store/types/api-types';
import CloseIcon from '@mui/icons-material/Close';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import {
  emailRegex,
  individualPanRegex,
  nonIndividualPanRegex,
  numberRegex,
  phoneRegExp,
} from '../../utils/regex';
import { Location } from 'history';
import { Notes } from '../investors/components';
import MFCheckbox from '../../lib/formik/Checkbox';

// import { DatePicker } from '../../lib/formik/DatePicker';
import { TextDatePicker } from './DatePickerWithTextFeild';

import {
  futureAge,
  getCountryCodes,
  getUniqueIdentityText,
  isMinor,
  isOnboardingTypeMinor,
  maxAge,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  APPLICATION_TYPE,
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  IS_DOB_APPLICABLE_FOR_AMC,
  ONBOARDING_KYC_VERIFIED_MESSAGE,
  ONBOARDING_OPTIONS,
  ONBOARDING_VIA_OPTIONS,
  PHYSICAL_DIGITAL_FLOW,
  USER_ROLES,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { AmlPopup, AmlPopupValues, CountryCodesDropDown } from '../commonComponents';
import { Link as RouterLink } from 'react-router-dom';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import 'react-datepicker/dist/react-datepicker.css';
import { DayJsDatePicker } from './newDatePicker';
import dayjs from '../../utils/dayjs';
import PersonIcon from '../../assets/icons/PersonIcon';
import GroupIcon from '../../assets/icons/GroupIcon';
import TickIcon from '../../assets/icons/TickIcon';
import { InfoIconOutlined } from '../../assets/SvgIcons';
import CompanyIcon from '../../assets/icons/CompanyIcon';
import { showError } from '../../redux-store/actions/auth';
import KycInfoPopup from './KycInfoPopup';

interface Values {
  pan: string;
  dob: string;
  onboardingType: string;
  onboardingVia?: string;
  accountType: string;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
  accountType: string;
}
interface EValues {
  pan: string;
  emailId: string;
  mobile: string;
  countryNameAndCode: string;
  dob: string;
  accountType: string;
}

interface InvestorTypeProps {
  value: string;
  label: string;
  isDisabled: boolean;
  activeType: string;
  handleClick: Dispatch<SetStateAction<string>>
}


const dateOfBirthLabelMap: Record<string, string> = {
  individual: "Date of Birth (DD/MM/YYYY)",
  minor: "Guardian Date of Birth (DD/MM/YYYY)",
  nri: "Date of Birth (DD/MM/YYYY)",
  nonindividual: "Date of Incorporation/ Registration (DD/MM/YYYY)"
}

const onboardingTypes: Array<{ label: string; value: string; }> = [
  {
    label: "Individual",
    value: 'individual'
  },
  {
    label: "Minor",
    value: "minor"
  },
  {
    label: "NRI",
    value: "nri"
  },
  {
    label: "Non Individual",
    value: "nonIndividual"
  }
]


const applicationTypeMap: Record<string, string> = {
  individual: APPLICATION_TYPE.INDIVIDUAL,
  minor: APPLICATION_TYPE.MINOR,
  nri: APPLICATION_TYPE.NRI,
  nonIndividual: APPLICATION_TYPE.NON_INDIVIDUAL
}

const applicantStatusMap: Record<string, string> = {
  individual: "individual",
  minor: "individual",
  nri: "nri",
  nonIndividual: "nonindividual"
}

const onboardingTypeJointHolderMap: Record<string, string> = {
  individual: "individual",
  nri: "nri",
  nonindividual: "nonIndividual"
}

function InvestorType({
  value,
  label,
  isDisabled,
  activeType,
  handleClick
}: InvestorTypeProps) {

  const theme = useTheme()

  const activeStyle = {
    borderWidth: "1px",
    borderColor: "primary.500",
    backgroundColor: `${theme.palette.primary[500]}1A`,
    cursor: 'pointer'
  }

  const inActiveStyle = {
    borderWidth: "0.5px",
    borderColor: "text.secondary",
    backgroundColor: `${theme.palette.background.paper}0D`,
    cursor: 'pointer'
  }

  const disabledStyle = {
    borderWidth: "1px",
    borderColor: "text.disabled",
    backgroundColor: "text.disabled",
    cursor: 'not-allowed'
  }

  const styleObj: any = {
    currentStyle: null,
    fillColor: null,
    strokeColor: null,
    textColor: null
  }

  if (isDisabled) {
    styleObj.currentStyle = disabledStyle
    styleObj.fillColor = theme.palette.text.secondary
    styleObj.textColor = theme.palette.text.secondary
    styleObj.strokeColor = theme.palette.text.secondary
  } else if (activeType === value) {
    styleObj.currentStyle = activeStyle
    styleObj.fillColor = theme.palette.primary[500]
    styleObj.textColor = theme.palette.primary[500]
    styleObj.strokeColor = theme.palette.primary[500]
  } else {
    styleObj.currentStyle = inActiveStyle
    styleObj.strokeColor = theme.palette.text.secondary
    styleObj.textColor = theme.palette.text.secondary
  }

  const iconsObj: Record<string, JSX.Element> = {
    individual: <PersonIcon
      fillColor={styleObj.fillColor}
      strokeColor={styleObj.strokeColor}
    />,
    minor: <GroupIcon
      fillColor={styleObj.fillColor}
      strokeColor={styleObj.strokeColor}
    />,
    nri: <PersonIcon
      fillColor={styleObj.fillColor}
      strokeColor={styleObj.strokeColor}
    />,
    nonIndividual: <CompanyIcon
      strokeColor={styleObj.strokeColor}
    />
  }


  return (
    <Button
      onClick={() => {
        if (isDisabled) return

        handleClick(value)
      }}
      sx={{
        borderRadius: "15px",
        px: (value === "normal" ? "20px" : "33px"),
        py: (activeType === value ? "25.5px" : "26px"),
        borderStyle: "solid",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        rowGap: "5px",
        color: `${theme.palette.primary[500]}66`,
        ...styleObj.currentStyle
      }}>
      {iconsObj[value]}
      <Typography variant='body_500' color={styleObj.textColor}>{label}</Typography>
    </ Button>
  )
}

interface KycRegistrationValues {
  email: string;
  name: string;
}

const kycRegistrationInitialValues: KycRegistrationValues = {
  email: '',
  name: ''
}

const kycRegistrationValidationSchema = yup.object().shape({
  email: yup
    .string()
    .required("Email ID is required")
    .matches(emailRegex, 'Invalid Email ID'),
  name: yup
    .string()
    .required('Name as per PAN is required'),
})

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
  }>;
}): JSX.Element {
  const enterPanFormikRef = useRef<FormikProps<Values>>(null);

  const { path: currentPathName } = useRouteMatch();
  const { redirectTo = '', firstHolderName = '', application } = location.state || {};
  const { id, applicants = [], hasPOA, onboardingVia } = application || {};
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const [amlPopup, setAmlPopup] = React.useState<{
    panVerificationToken: string;
    pan: string;
    dob: string;
  } | null>(null);
  const [amlFailedresponse, setAmlFailedresponse] = React.useState<AmlSystemMatch>();
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);
  const [isKycRegistrationPopupOpen, setKycRegistrationPopupOpen] = useState<boolean>(false)
  const [kycRegistrationLoading, setKycRegistrationLoading] = useState<boolean>(false)
  const [kycRegLinkData, setKycRegLinkData] = useState<MfuKycOnboardingResponseBody | null>(null)
  const [kycRegLinkPopupOpen, setKycRegLinkPopupOpen] = useState<boolean>(false)
  const [kycValLinkData, setKycValLinkData] = useState<VerifyPanResponseBody | null>(null)
  const [kycValLinkPopupOpen, setKycValLinkPopupOpen] = useState<boolean>(false)
  const [applicationTypes, setApplicationTypes] = useState<{
    code: string;
    description: string;
  }[]>([])
  const [isApplicationTypesLoading, setApplicationTypesLoading] = useState<boolean>(false)
  const [selectedAccountType, setSelectedAccountType] = useState<string>("")

  const currentDate = dayjs();

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-pan-number'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')
  const showRadioGroup = (id && redirectTo) ? onboardingVia === 'physical' : true
  useEffect(() => {
    const fetchApplicationTypes = async () => {
      try {
        setApplicationTypesLoading(true)

        const response = await (dispatch(getApplicationTypes()) as unknown as Promise<{ code: string; description: string }[]>)

        setApplicationTypes(response ?? [])

        if (response && response.length > 0) {
          const executionaryType = response.find(item => item.code === "EXECUTIONARY")
          const defaultAccountType = executionaryType?.code ?? response[0].code ?? ""

          setSelectedAccountType(defaultAccountType)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setApplicationTypesLoading(false)
      }
    }

    fetchApplicationTypes()
  }, [])

  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);
  const validationSchema1 = yup.object().shape({
    onboardingType: yup.string().required(),
    pan: yup
      .string()
      .uppercase()
      // .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }
        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (
            (
              parent?.onboardingType === "individual" ||
              parent?.onboardingType === "minor" ||
              parent?.onboardingType === "nri"
            ) &&
            !individualPanRegex.test(fieldValue)
          ) {
            return createError({
              message: 'Only Individual PANs are allowed',
              path,
            });
          }

          if (
            parent?.onboardingType === "nonIndividual" &&
            (
              // To check the format for PAN entered
              !nonIndividualPanRegex.test(fieldValue)
            )
          ) {
            return createError({
              message: 'Only Non Individual PANs are allowed',
              path,
            });
          }
        }

        // if (!individualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'Only individual PANs are allowed',
        //     path,
        //   });
        // }
        // if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'invalid PAN',
        //     path,
        //   });
        // }
        // if (!nonIndividualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'invalid PAN',
        //     path,
        //   });
        // }
        if (parent?.onboardingType !== "nonIndividual" && applicantPanNumbers.includes(fieldValue)) {
          return createError({
            message: 'There is already same pan for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    dob: yup
      .string()
      .nullable()
      .test('dob', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (IS_DOB_APPLICABLE_FOR_AMC) {
          if (!fieldValue) {
            return createError({
              message: 'Date of Birth is required',
              path,
            });
          }
          if (futureAge(fieldValue || '')) {
            return createError({
              message: 'Invalid Date',
              path,
            });
          }
          if (isMinor(fieldValue || '') && parent?.onboardingType !== "nonIndividual") {
            return createError({
              message: 'Age should be greater than 18',
              path,
            });
          }
          if (maxAge(fieldValue || '') && parent?.onboardingType !== "nonIndividual") {
            return createError({
              message: 'Age should be less than 125',
              path,
            });
          }
        }

        return true;
      }),
    accountType: yup
      .string()
      .test('is-required', (value, context) => {
        const { path, createError } = context;
        if (id) {
          return true
        } else {
          if (!value) {
            return createError({
              message: 'Please select an account type',
              path,
            });
          }
          return true
        }
      }),
  });
  const initialValues1: Values = {
    pan: '',
    dob: dayjs(currentDate).format("YYYY-MM-DD"),
    onboardingType: id ? (onboardingTypeJointHolderMap[application?.applicants?.[0]?.applicantStatus ?? ""] ?? "") : 'individual',
    ...(PHYSICAL_DIGITAL_FLOW ? { onboardingVia: id ? onboardingVia : 'physical' } : {}),
    accountType: id ? (application?.accountType ?? "") : selectedAccountType,
  };
  const routingAfterPanVerification = async (
    response: VerifyPanResponseBody | AcknowledgeAmlCheckResponseBody,
    pan: string,
    dob: string,
    onboardingVia?: string,
  ) => {
    const currentAccountType = enterPanFormikRef?.current?.values?.accountType ?? selectedAccountType ?? ""

    if (hasPOA) {
      const { panVerificationToken } = response || {};
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await dispatch(addJointHolder({ applicantVerificationToken }, id));
      history.push(redirectTo, { id });
      return;
    }
    if (response.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL || onboardingVia === "physical") {
      return history.push('enter-email-id', {
        pan: pan.toUpperCase(),
        dob: dob,
        onboardingVia: onboardingVia,
        ...(response || {}),
        application,
        redirectTo,
        onboardingType: response?.applicationType,
        accountType: currentAccountType
      });
    }
    history.push('enter-mobile-number', {
      pan: pan.toUpperCase(),
      dob: dob,
      ...(response || {}),
      redirectTo,
      firstHolderName,
      application,
      accountType: currentAccountType
    });
  };

  const handleSubmit1 = async (values: Values) => {
    setAmlAcknowledgementLoading(true);
    try {
      const {
        pan,
        onboardingType,
        onboardingVia,
        accountType
      } = values;

      const dob = dayjs(values.dob, "YYYY-MM-DD").format("YYYY-MM-DD")

      const response = (await dispatch(
        verifyPan({
          pan,
          dob,
          onboardingType: (
            (onboardingType === "individual") ||
            (onboardingType === "nri") ||
            (onboardingType === "nonIndividual")
          ) ? "normal" : "minor",
          onboardingVia: onboardingVia,
          applicationType: applicationTypeMap[onboardingType ?? ""] ?? "",
          applicantStatus: applicantStatusMap[onboardingType ?? ""] ?? "",
          accountType
        }, false)
      )) as unknown as VerifyPanResponseBody

      if (!response) return

      if (response?.isSuccess === false && response?.isRegistered === false) {
        setKycRegistrationPopupOpen(true)

        return
      }

      if (response?.isSuccess === false && response?.isRegistered === true) {
        setKycValLinkData(response)
        setKycValLinkPopupOpen(true)

        return
      }

      if (!response.amlCheck) {
        setAmlFailedresponse(response.amlData.system_match[0]);
        return setAmlPopup({
          panVerificationToken: response.panVerificationToken,
          pan: pan,
          dob: dob,
        });
      }

      if (response?.isSuccess === true) {
        if ((isInvestorDiyOnboarding || isDiyJointHolder)) {
          routingAfterPanVerification(response, pan, dob);
        }
        else {
          routingAfterPanVerification(response, pan, dob, onboardingVia);
        }

        return
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  };
  const handleClose = () => {
    setAmlPopup(null);
  };

  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const { amlComments, amlAcknowledgement } = values;
      const { panVerificationToken = '', pan = '', dob = '' } = amlPopup || {};
      setAmlPopup(null);
      const response = (await dispatch(
        AcknowledgeAmlCheck({ panVerificationToken, amlComments, amlAcknowledgement })
      )) as unknown as AcknowledgeAmlCheckResponseBody;
      routingAfterPanVerification(response, pan, dob, enterPanFormikRef?.current?.values?.onboardingVia ?? "");
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  const handleCloseKycRegistrationPopup = () => {
    setKycRegistrationPopupOpen(false)
  }

  const handleKycRegistrationSubmit = async (values: KycRegistrationValues) => {
    try {

      if (!enterPanFormikRef?.current) return

      setKycRegistrationLoading(true)

      const payload = {
        panNo: enterPanFormikRef?.current?.values?.pan ?? "",
        emailId: values?.email ?? "",
        investorName: values?.name ?? ""
      }

      const response = (await dispatch(MfuKycOnboarding(payload))) as unknown as MfuKycOnboardingResponseBody

      if (response) {
        handleCloseKycRegistrationPopup()
        setKycRegLinkData(response)
        setKycRegLinkPopupOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setKycRegistrationLoading(false)
    }
  }

  const handleCloseKycRegLinkPopup = () => {
    setKycRegLinkPopupOpen(false)

    history.push("/kyc-applications")
  }

  const handleCloseKycValLinkPopup = () => {
    enterPanFormikRef?.current?.resetForm()

    setKycValLinkPopupOpen(false)
  }

  return (
    <>
      {isApplicationTypesLoading && (
        <Box width="100%">
          <LinearProgress />
        </Box>
      )}
      {!isApplicationTypesLoading && (
        <>
          <Formik
            innerRef={enterPanFormikRef}
            initialValues={initialValues1}
            validationSchema={validationSchema1}
            onSubmit={handleSubmit1}
            enableReinitialize
          >
            {({ handleSubmit, resetForm, values, setFieldValue }) => (
              <>
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  {/* <UseRadioGroup
                disabled={id ? true : false}
                formLabel="Investor Type*"
                name="onboardingType"
                items={Object.keys(onboardingTypeMasters).map((type) => ({
                  value: type,
                  label: onboardingTypeMasters[type],
                }))}
              /> */}
                  <Typography variant='body_500' color="text.secondary">Investor Type</Typography>
                  <Grid container mt={1} mb={3} spacing={1.5}>
                    {onboardingTypes
                      .filter(obj => !(
                        (isInvestorDiyOnboarding || isDiyJointHolder) &&
                        (obj.value === "minor" || obj.value === "nonIndividual")))
                      .map((
                        obj: {
                          label: string;
                          value: string;
                        }) =>
                        <Grid key={obj?.value} item>
                          <InvestorType
                            value={obj?.value}
                            label={obj?.label}
                            isDisabled={id ? true : false}
                            activeType={values?.onboardingType}
                            handleClick={() => setFieldValue("onboardingType", obj?.value)}
                          />
                        </Grid>
                      )}
                  </Grid>
                  {/* isOnboardingTypeMinor(values.onboardingType) */}
                  {isOnboardingTypeMinor(values?.onboardingType) && (
                    <Box
                      // sx={{
                      //   '& .MuiSvgIcon-root': { display: 'none' },
                      //   '& .MuiTypography-root': { ml: 0 },
                      // }}
                      mt={5}
                      mb={3}
                    >
                      <Notes
                        displayContent={
                          'You have selected Minor Investor Onboarding. Please provide Guardian PAN and Date of Birth'
                        }
                        showIcon={false}
                      />
                    </Box>
                  )}
                  <Grid container flexDirection="column" rowSpacing={2}>
                    <Grid item>
                      <MFTextField
                        // label={isOnboardingTypeMinor(values.onboardingType) ? 'Guardian PAN' : 'PAN'}
                        label={isOnboardingTypeMinor(values?.onboardingType) ? `Guardian ${getUniqueIdentityText(company)?.panNumber}` : `${getUniqueIdentityText(company)?.panNumber}`}
                        name="pan"
                        placeholder={`${getUniqueIdentityText(company)?.pan}`}
                        required
                        autoComplete="off"
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                      />
                    </Grid>
                    {IS_DOB_APPLICABLE_FOR_AMC && (
                      <Grid item>
                        <DayJsDatePicker
                          id={id}
                          name='dob'
                          label={dateOfBirthLabelMap[`${values?.onboardingType ?? ""}`.toLowerCase()] ?? "Date of Birth (DD/MM/YYYY)"}
                          maxDate={new Date()}
                          minDate={new Date('1800-01-01')}
                          resetDate
                        />
                      </Grid>
                    )}
                  </Grid>
                  {PHYSICAL_DIGITAL_FLOW && (!(isInvestorDiyOnboarding || isDiyJointHolder) && showRadioGroup && (
                    <Grid item xs={12} pt={3} pb={1}>
                      <UseRadioGroup
                        formLabel=""
                        name="onboardingVia"
                        defaultValue="physical"
                        disabled={id ? true : false}
                        items={Object.keys(ONBOARDING_VIA_OPTIONS).map(obj => ({
                          label: ONBOARDING_VIA_OPTIONS[obj],
                          value: obj
                        }))}
                      />
                    </Grid>
                  ))
                  }
                  {(applicationTypes.length > 0) && (
                    <Grid item xs={12} pt={3} pb={1}>
                      <UseRadioGroup
                        formLabel=""
                        name="accountType"
                        disabled={id ? true : false}
                        items={applicationTypes.map(obj => ({
                          label: obj?.description ?? "",
                          value: obj?.code ?? ""
                        }))}
                      />
                    </Grid>
                  )}
                  <Box mt={5} mb={3}>
                    <MFSubmitButton label={` Verify ${getUniqueIdentityText(company)?.pan}`} loadingEnable={amlAcknowledgementLoading} />
                  </Box>
                  {(
                    ["executionary", "advisory"].includes(`${id ? (application?.accountType ?? "") : (values?.accountType ?? "")}`.toLowerCase()) &&
                    `${values?.onboardingVia ?? ""}`.toLowerCase() === "physical"
                  ) && (
                      <Grid item xs={12} py={2}>
                        <Notes
                          displayContent={
                            'Fetch KYC Data Consent document upload is mandatory. Please upload it in the Document Upload section.'
                          }
                        />
                      </Grid>
                    )}
                  {(currencyCode?.toLowerCase() === "inr") && (
                    <Notes
                      displayContent={
                        'Add the applicant(s) PAN and if the PAN is KRA verified, the contact details will be populated automatically. PAN will be checked against World-Check database for AML compliance.'
                      }
                      icon={<InfoIconOutlined />}
                    />
                  )}
                </Box>
                <Dialog open={open} onClose={() => setOpen(false)}>
                  <Box
                    sx={{
                      p: { xs: 2, sm: 8 },
                      borderRadius: '10px',
                      // width: { xs: '70%', sm: '70%' },
                      maxWidth: 800,
                      height: { xs: '90%', md: 'unset' },
                      overflowY: 'auto',
                    }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '& .MuiButton-root': {
                          minWidth: 200,
                          fontSize: 16,
                        },
                      }}>
                      <Box sx={{ mb: 8 }}>
                        <CardMedia
                          component="img"
                          src="/images/warning-icon-red.svg"
                          sx={{ width: 'unset' }}
                        />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontWeight: 500,
                          color: '#337FC9',
                          textAlign: 'center',
                          width: '70%',
                          mb: 5,
                        }}>
                        Unable to verify the details please contact admin
                      </Typography>
                      <Button
                        // component={RouterLink}
                        variant="contained"
                        onClick={() => {
                          resetForm();
                          setOpen(false);
                        }}
                        sx={{ color: 'common.white' }}>
                        Enter another PAN
                      </Button>
                    </Box>
                  </Box>
                </Dialog>
                <AmlPopup
                  handleClose={handleClose}
                  amlPopupOpen={amlPopup !== null}
                  onSubmit={onSubmit}
                  FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
                  EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
                  displayDocInfo={true}
                />
              </>
            )}
          </Formik >
          <Dialog
            open={isKycRegistrationPopupOpen}
            onClose={handleCloseKycRegistrationPopup}
          >
            <DialogTitle
              variant='h2'
              sx={{ textAlign: 'center' }}
            >
              KYC Not Registered
            </DialogTitle>
            <Typography
              variant="body_500"
              sx={{
                textAlign: 'center',
                px: 3,
                pb: 1
              }}
            >
              Please enter below details for KYC Registration
            </Typography>
            <DialogContent>
              <Formik
                initialValues={kycRegistrationInitialValues}
                validationSchema={kycRegistrationValidationSchema}
                onSubmit={handleKycRegistrationSubmit}
              >
                {() => {
                  return (
                    <Form autoComplete='off'>
                      <MFTextField
                        label="Email ID *"
                        name="email"
                        placeholder="Enter Email ID"
                        disabled={kycRegistrationLoading}
                      />
                      <MFTextField
                        label="Name as per PAN *"
                        name="name"
                        placeholder="Enter Name as per PAN"
                        disabled={kycRegistrationLoading}
                      />
                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="outlined"
                            fullWidth
                            sx={(theme: Theme) => ({
                              ...theme.typography.body_600,
                              color: 'text.primary',
                              padding: '7px'
                            })}
                            onClick={handleCloseKycRegistrationPopup}
                            disabled={kycRegistrationLoading}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <MFSubmitButton
                            label="Submit"
                            loadingEnable={kycRegistrationLoading}
                            loadingPosition="center"
                            sx={{ padding: '7px' }}
                          />
                        </Grid>
                      </Grid>
                    </Form>
                  )
                }}
              </Formik>
            </DialogContent>
          </Dialog >
          <KycInfoPopup
            open={kycRegLinkPopupOpen}
            title={kycRegLinkData?.message ?? ""}
            subtitle={kycRegLinkData?.kycOnboardingURL ?? ""}
            copyText={kycRegLinkData?.kycOnboardingURL ?? ""}
            submitButtonLabel="Okay"
            onSubmitBtnClick={handleCloseKycRegLinkPopup}
          />
          <KycInfoPopup
            open={kycValLinkPopupOpen}
            title={kycValLinkData?.message ?? ""}
            copyLinks={kycValLinkData?.url}
            submitButtonLabel="Okay"
            onSubmitBtnClick={handleCloseKycValLinkPopup}
          />
        </>
      )}
    </>
  );
}
export function EnterMobile({
  location,
}: {
  location: Location<{
    redirectTo: string;
    panVerificationToken: string;
    pan: string;
    firstHolderName: string;
    application: ApplicationProps;
    dob: string;
    amlCheck: boolean;
    applicationType?: string;
    accountType: string;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    panVerificationToken,
    pan,
    firstHolderName = '',
    application,
    dob,
    amlCheck = false,
    applicationType = "",
    accountType = ""
  } = location.state || {};
  const theme = useTheme()
  const { path: currentPathName } = useRouteMatch();

  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  // const [applicationTypes, setApplicationTypes] = useState<{
  //   code: string;
  //   description: string;
  // }[]>([])
  // const [isApplicationTypesLoading, setApplicationTypesLoading] = useState<boolean>(false)
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-mobile-number'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')

  const validationSchema1 = (id: string) => yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      // .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }
        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && !individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }

          if (!nonIndividualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }
        }
        return true;
      }),
    emailId: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path, parent } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        // const codesList = getCountryCodes()
        //   .map((codes) => {
        //     if (codes.label === parent.countryNameAndCode) {
        //       return codes.countryCode;
        //     }
        //   })
        //   .filter((ele) => ele)
        //   .toString();

        const selectedCodeObj = (getCountryCodes() ?? []).find((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes;
          }
        })

        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }

        if (!numberRegex.test(`${value ?? ""}`)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }

        if (
          `${selectedCodeObj?.countryCode ?? ""}`.toLowerCase() === "in" &&
          `${value ?? ""}`.length !== 10
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }

        // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
        //   return createError({
        //     message: 'Invalid Mobile number',
        //     path,
        //   });
        // }
        // if (!isValidPhoneNumber(value, codesList as CountryCode)) {
        //   return createError({
        //     message: 'Invalid Mobile number',
        //     path,
        //   });
        // }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => (disablePOA ? true : !value),
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          // const codesList = getCountryCodes()
          //   .map((codes) => {
          //     if (codes.label === value) {
          //       return codes.countryCode;
          //     }
          //   })
          //   .filter((ele) => ele)
          //   .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          // if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
          //   return createError({
          //     message: 'Invalid Mobile number',
          //     path,
          //   });
          // }

          return true;
        }),
      }),
    // accountType: yup
    //   .string()
    //   .test('is-required', (value, context) => {
    //     const { path, createError } = context;
    //     if (id) {
    //       return true
    //     } else {
    //       if (!value) {
    //         return createError({
    //           message: 'Please select an account type',
    //           path,
    //         });
    //       }
    //       return true
    //     }
    //   }),
  })
  const initialValues1: MValues = {
    pan: pan,
    mobile: '',
    emailId: '',
    bypassOtp: false,
    skipOtpModal: false,
    hasPOA: false,
    dob: dob,
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    onboardingOtpEmailConsent: 'otp',
    accountType: id
      ? ""
      : (isInvestorDiyOnboarding)
        ? "EXECUTIONARY"
        : accountType
  };

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as CreateApplicationProps;
    if (!res?.isSuccess) {
      dispatch(showError(res?.message as string));
      return;
    }
    history.push('/application/rm-details', { ...(res?.application || {}) });
  };

  const handleSubmit1 = async (values: MValues) => {
    try {

      const {
        pan,
        mobile = '',
        bypassOtp = false,
        hasPOA,
        emailId,
        countryCode = '+91',
        countryNameAndCode = 'India: +91',
        onboardingOtpEmailConsent = 'otp',
        accountType = ""
      } = values;
      if (hasPOA) {
        const poaResponse = (await dispatch(
          EnablePOA({ panVerificationToken, powerOfAttorney: true })
        )) as unknown as EnablePOAResponseBody;

        if (!poaResponse) return

        const { applicantVerificationToken } = poaResponse;
        await handleCreateApplication(applicantVerificationToken);
        return;
      }
      if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
        const sendConsentEmailResponse = (await dispatch(
          sendConsentEmail({
            phoneNumber: mobile.trim(),
            emailId,
            panVerificationToken,
            countryCode: countryNameAndCode?.split(':')[1].trim(),
            countryNameAndCode,
            applicationId: id || '',
            accountType
          })
        )) as unknown as SendConsentEmailResponseBody;

        if (!sendConsentEmailResponse) return

        enqueueSnackbar('Email sent successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        return history.push(
          [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
            ? `/applications-list`
            : '/applications'
        );
      }

      const sendOtpResponse = (await dispatch(
        sendOtp({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          bypassOtp,
          // ...((isInvestorDiyOnboarding || isDiyJointHolder) ?
          //   {
          //     accountType: isDiyJointHolder ? "" : "EXECUTIONARY"
          //   } : { accountType })
          accountType
        }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as SendOtpResponseBody;

      if (!sendOtpResponse) return

      const { applicantVerificationToken, phoneNumber } = sendOtpResponse || {};

      if (bypassOtp) {
        if (id && redirectTo) {
          const res = (await dispatch(
            addJointHolder({ applicantVerificationToken }, id)
          )) as unknown as CreateApplicationProps;
          if (!res?.isSuccess) {
            dispatch(showError(res?.message as string));
            return;
          }
          history.push(redirectTo, { id });
          return;
        }
        handleCreateApplication(applicantVerificationToken);
        return;
      }

      history.push('enter-otp', {
        pan,
        unmaskedphone: mobile.trim(),
        umaskedemailId: emailId,
        mobile: phoneNumber,
        panVerificationToken,
        redirectTo,
        application,
        email: (sendOtpResponse || {}).emailId,
        firstHolderName,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
        accountType,
        ...(sendOtpResponse || {}),
      });

    } catch (error) {
      console.log("Error: ", error)
    }
  };

  // useEffect(() => {
  //   (async function () {
  //     const res = (await dispatch(
  //       IsApplicableForPOA()
  //     )) as unknown as IsApplicableForPOAResponseBody;
  //     const { powerOfAttorney } = res;
  //     setDisablePOA(
  //       application
  //         ? application.hasPOA
  //           ? application.hasPOA
  //           : !application.hasPOA
  //         : !powerOfAttorney
  //     );
  //   })();
  // }, []);
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    // const fetchApplicationTypes = async () => {
    //   if (isInvestorDiyOnboarding || isDiyJointHolder) {
    //     return
    //   }

    //   try {
    //     setApplicationTypesLoading(true)

    //     const response = await (dispatch(getApplicationTypes()) as unknown as Promise<{ code: string; description: string }[]>)

    //     setApplicationTypes(response ?? [])
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setApplicationTypesLoading(false)
    //   }
    // }

    // fetchApplicationTypes()
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1(id)}
        onSubmit={handleSubmit1}
        enableReinitialize={true}
      >
        {({
          handleSubmit,
          values,
          validateForm,
          isSubmitting,
          setTouched,
          setErrors,
          setFieldValue,
        }) => (
          (
            <>
              <Grid container component="form" noValidate onSubmit={handleSubmit}>
                {/* <Box sx={{ position: 'relative' }}> */}
                {/* <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                  <CardMedia
                    component="img"
                    src="/images/tick.svg"
                    sx={{ width: '18px', float: 'right' }}
                  />
                  </Box> */}
                <Grid item container xs={12} mb={1}>
                  <MFTextField
                    label="PAN Number"
                    name="pan"
                    placeholder="Enter PAN"
                    required
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    disabled={true}
                    applyMarginBottom={false}
                    endAdornment={
                      <InputAdornment position="end">
                        <TickIcon fillColor={theme.palette.success[800]} />
                      </InputAdornment>
                    }
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: 'success.800', mb: 0.5 }}>
                    {ONBOARDING_KYC_VERIFIED_MESSAGE ? `KYC Verified,${' '}` : ''}
                    <Typography
                      variant="body2"
                      component={'span'}
                      sx={{
                        fontWeight: 600,
                        color: amlCheck ? 'success.800' : 'error.500',
                        mb: 0.5,
                      }}>
                      AML Check {amlCheck ? 'Passed' : 'Failed'}
                    </Typography>
                  </Typography>
                </Grid>
                {IS_DOB_APPLICABLE_FOR_AMC && (
                  <Grid item xs={12}>
                    <TextDatePicker
                      label={'Date of Birth'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: `${theme.palette.common.black}B3`
                      }}
                      placeholder={'Enter Date of Birth'}
                      name="dob"
                      disabled={true}
                      minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                    />
                  </Grid>
                )}

                {/* <MFCheckbox
                  name="hasPOA"
                  label="Power of Attorney"
                  color="primary"
                  sx={{
                    '.MuiTypography-root': {
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 14,
                      letterSpacing: '0.9625px',
                    },
                  }}
                  disabled={disablePOA}
                /> */}
                {!values.hasPOA && (
                  <>
                    <Grid item xs={12}>
                      <MFTextField
                        label="Mobile Number"
                        name="mobile"
                        placeholder="Enter Mobile number"
                        onKeyDown={(e) => {
                          preventSpecialCharacters(e);
                        }}
                        startAdornment={
                          <CountryCodesDropDown
                            ElementWidth={mobileElementWidth && mobileElementWidth}
                            name={'countryNameAndCode'}
                            value={values.countryNameAndCode}
                          />
                        }
                      />
                    </Grid>
                    {ENABLE_EMAIL_OTP && (
                      <Grid item xs={12}>
                        <MFTextField
                          autoComplete="off"
                          // autoFocus
                          label="Email ID"
                          name="emailId"
                          placeholder="Enter Email ID"
                          required
                        />
                      </Grid>
                    )}
                    {ENABLE_Email_Consent && (
                      <Grid item xs={12} pt={3} pb={1}>
                        <UseRadioGroup
                          formLabel=""
                          name={`onboardingOtpEmailConsent`}
                          defaultValue="otp"
                          items={Object.keys(ONBOARDING_OPTIONS)
                            .filter(type => !((isInvestorDiyOnboarding || isDiyJointHolder) && type === 'email_consent'))
                            .map((option) => ({
                              label: ONBOARDING_OPTIONS[option],
                              value: option,
                            }))}
                        />
                      </Grid>
                    )}
                    {/* {!(isInvestorDiyOnboarding || isDiyJointHolder) && (
                      <>
                        {isApplicationTypesLoading && (
                          <Grid
                            item
                            container
                            pt={3}
                            pb={1}
                            spacing={2}
                            flexWrap={{ xs: "wrap", lg: "nowrap" }}
                          >
                            {[...Array(3)].map((_, index) => (
                              <Grid
                                item
                                key={index}
                                width="100%"
                              >
                                <Skeleton
                                  animation="wave"
                                  variant="rounded"
                                  height={45}
                                  width="100%"
                                />
                              </Grid>
                            ))}
                          </Grid>
                        )}
                        {!isApplicationTypesLoading && (
                          <Grid item xs={12} pt={3} pb={1}>
                            <UseRadioGroup
                              formLabel=""
                              name="accountType"
                              disabled={id ? true : false}
                              items={applicationTypes.map(obj => ({
                                label: obj?.description ?? "",
                                value: obj?.code ?? ""
                              }))}
                            />
                          </Grid>
                        )}
                      </>
                    )} */}
                    <Grid item xs={12} py={2}>
                      <Notes
                        displayContent={
                          // 'Provide the mobile number which is registered in KRA database. Applicants Identity details will be fetched from the KRA database.'
                          'This mobile number and email id will be used for all future communication related to this investment.'
                        }
                        icon={<InfoIconOutlined />}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} py={2}>
                  <MFSubmitButton
                    // disabled={isSubmitting || isApplicationTypesLoading}
                    disabled={isSubmitting}
                    label={
                      values.hasPOA
                        ? 'Continue'
                        : ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                          ONBOARDING_OPTIONS.email_consent
                          ? 'Send Email'
                          : 'Get OTP'
                    }
                  />
                </Grid>
                {/* {!(isInvestorDiyOnboarding || isDiyJointHolder) &&
                  !values.hasPOA &&
                  ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                  ONBOARDING_OPTIONS.otp && (
                    <Grid item xs={12} py={1}>
                      <Button
                        variant="outlined"
                        fullWidth
                        sx={{
                          color: 'text.secondary',
                          backgroundColor: "transparent",
                          borderWidth: "0.5px",
                          borderStyle: "solid",
                          borderColor: "text.secondary",
                          padding: "10px",
                          "&:hover, &.Mui-focusVisible": { borderColor: 'text.secondary', backgroundColor: "background.default" }
                        }}
                        disabled={isSubmitting || isApplicationTypesLoading}
                        onClick={async () => {
                          const error = await validateForm();
                          if (Object.keys(error).length) {
                            setTouched(setNestedObjectValues(error, true));
                            setErrors(error);
                            return;
                          }
                          setFieldValue('skipOtpModal', true);
                        }}>
                        Skip OTP Verification
                      </Button>
                    </Grid>
                  )} */}
              </Grid>
              <Dialog
                open={values.skipOtpModal}
                onClose={() => setFieldValue('skipOtpModal', false)}
                maxWidth='sm'
                fullWidth
                sx={{
                  '& .MuiPaper-root': {
                    borderRadius: '15px',
                    backgroundColor: "background.paper",
                    rowGap: "15px",
                  },
                }}
              >
                <DialogContent sx={{ paddingTop: "25px" }}>
                  <Typography variant='h2' color="text.primary" mb="10px">Skip OTP Verification</Typography>
                  <Typography variant='subtitle_400' color="text.secondary">Are you sure you want to skip OTP verification?</Typography>
                </DialogContent>
                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                  <Button
                    variant="outlined"
                    disabled={isSubmitting}
                    onClick={() => setFieldValue('skipOtpModal', false)}
                    sx={(theme: Theme) => ({
                      color: theme.palette.text.secondary,
                      flex: 1,
                      border: `0.5px solid ${theme.palette.text.secondary}`,
                      padding: "10px",
                      "&:hover, &.Mui-focusVisible": {
                        borderColor: theme.palette.text.secondary,
                        backgroundColor: theme.palette.background.default
                      }
                    })}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    sx={(theme: Theme) => ({
                      flex: 1,
                      color: theme.palette.textDark.primary,
                      padding: "10px"
                    })}
                    onClick={() => {
                      setFieldValue('bypassOtp', true);
                      handleSubmit();
                      setFieldValue('skipOtpModal', false);
                    }}>
                    Continue
                  </Button>
                </DialogActions>
                {/* <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 3,
                      '& .MuiButton-root': {
                        minWidth: 200,
                        fontSize: 16,
                      },
                    }}> */}
                {/* <IconButton
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ alignSelf: 'flex-end' }}>
                      <CloseIcon fontSize="small" />
                    </IconButton> */}
                {/* <Box sx={{ mb: 4 }}>
                      <CardMedia
                        component="img"
                        src="/images/warning-icon-red.svg"
                        sx={{ width: 'unset' }}
                      />
                    </Box> */}
                {/* <Typography
                      sx={{
                        fontSize: 20,
                        fontWeight: 500,
                        color: '#337FC9',
                        textAlign: 'center',
                        mb: 5,
                        width: '90%',
                      }}>
                      Are you sure you want to Skip OTP Verification?
                    </Typography> */}
                {/* <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'space-around',
                      width: '100%',
                    }}>
                    <Button
                      variant="outlined"
                      disabled={isSubmitting}
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ color: 'primary.main', mb: 2 }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ mb: 2 }}
                      onClick={() => {
                        setFieldValue('bypassOtp', true);
                        handleSubmit();
                        setFieldValue('skipOtpModal', false);
                      }}>
                      Continue
                    </Button>
                  </Box> */}
                {/* </Box> */}
              </Dialog>
            </>
          )
        )
        }
      </Formik >
    </>
  );
}

export function EnterEmailId({
  location,
}: {
  location: Location<{
    panVerificationToken: string;
    pan: string;
    dob: string;
    amlCheck: boolean;
    application: ApplicationProps;
    onboardingVia?: string;
    redirectTo?: string;
    onboardingType?: string;
    applicationType?: string;
    accountType: string;
  }>;
}): JSX.Element {
  const theme = useTheme()
  const { panVerificationToken, pan, dob, amlCheck = false, application, onboardingVia, redirectTo, onboardingType, applicationType, accountType = "" } = location.state || {};
  const { id } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);

  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  // const [isApplicationTypesLoading, setApplicationTypesLoading] = useState<boolean>(false)
  // const [applicationTypes, setApplicationTypes] = useState<{
  //   code: string;
  //   description: string;
  // }[]>([])

  const isPhysicalOnboarding = `${onboardingVia ?? ""}`.toLowerCase() === "physical"

  useEffect(() => {
    // const fetchApplicationTypes = async () => {
    //   try {
    //     setApplicationTypesLoading(true)

    //     const response = await (dispatch(getApplicationTypes()) as unknown as Promise<{ code: string; description: string }[]>)

    //     setApplicationTypes(response ?? [])
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setApplicationTypesLoading(false)
    //   }
    // }

    // fetchApplicationTypes()
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, [])

  const validationSchema1 = (id: string) => yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      // .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }

        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && !individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }

          if (!nonIndividualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }
        }

        return true;
      }),

    emailId: yup
      .string()
      .nullable()
      .matches(emailRegex, 'invalid Email ID')
      .required('Email is required'),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => !value,
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        // const codesList = getCountryCodes()
        //   .map((codes) => {
        //     if (codes.label === parent.countryNameAndCode) {
        //       return codes.countryCode;
        //     }
        //   })
        //   .filter((ele) => ele)
        //   .toString();

        const selectedCodeObj = (getCountryCodes() ?? []).find((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes;
          }
        })

        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (!numberRegex.test(`${value ?? ""}`)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }

        if (
          `${selectedCodeObj?.countryCode ?? ""}`.toLowerCase() === "in" &&
          `${value ?? ""}`.length !== 10
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }


        // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
        //   return createError({
        //     message: 'Invalid Mobile number',
        //     path,
        //   });
        // }
        // if (!isValidPhoneNumber(value, codesList as CountryCode)) {
        //   return createError({
        //     message: 'Invalid Mobile number',
        //     path,
        //   });
        // }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => !value,
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;

          // const codesList = getCountryCodes()
          //   .map((codes) => {
          //     if (codes.label === value) {
          //       return codes.countryCode;
          //     }
          //   })
          //   .filter((ele) => ele)
          //   .toString();

          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          // if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
          //   return createError({
          //     message: 'Invalid Mobile number',
          //     path,
          //   });
          // }

          return true;
        }),
      }),
    // accountType: yup
    //   .string()
    //   .test('is-required', (value, context) => {
    //     const { path, createError } = context;
    //     if (id) {
    //       return true
    //     } else {
    //       if (!value) {
    //         return createError({
    //           message: 'Please select an account type',
    //           path,
    //         });
    //       }
    //       return true
    //     }
    //   }),
  });

  const initialValues1: EValues = {
    pan: pan,
    emailId: '',
    mobile: '',
    countryNameAndCode: 'India: +91',
    dob: dob,
    accountType: id ? "" : accountType
  };

  const handleSubmit1 = async (values: EValues) => {
    const { emailId, mobile, countryNameAndCode, accountType } = values;
    const response = (onboardingVia === 'physical')
      ? (await dispatch(
        physicalOnboarding({
          panVerificationToken,
          emailId,
          phoneNumber: mobile.trim(),
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          accountType
        })
      )) as unknown as VerifyOtpResponseBody
      :
      (await dispatch(
        SendEmail({
          panVerificationToken,
          emailId,
          phoneNumber: mobile.trim(),
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          bypassOtp: true,
          accountType
        })
      )) as unknown as VerifyOtpResponseBody;

    if (!response) return

    const { applicantVerificationToken } = response || {};

    if (id && redirectTo) {
      const res = (await dispatch(
        addJointHolder({ applicantVerificationToken }, id)
      )) as unknown as CreateApplicationProps;
      if (!res?.isSuccess) {
        dispatch(showError(res?.message as string));
        return;
      }
      history.push(redirectTo, { id });
      return;
    }


    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as CreateApplicationProps;

    if (!res) return

    if (!res?.isSuccess) {
      dispatch(showError((res?.message ?? "") as string));
      return;
    }

    if (onboardingVia === 'physical' && res?.application?.applicationType === 'individual') {
      history.push('/application', { ...(res?.application || {}) });
    } else {
      history.push('/non-individual-application', { ...(res?.application ?? {}) });
    }
    // history.push('verify-documents', {
    //   applicantVerificationToken,
    // });
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1(id)}
        onSubmit={handleSubmit1}
        enableReinitialize={true}
      >
        {({ values, handleSubmit, isSubmitting }) => {
          const isNonHeldAway = ["executionary", "advisory"].includes(`${id ? (application?.accountType ?? "") : (values?.accountType ?? "")}`.toLowerCase())
          return (
            <Grid container component="form" noValidate onSubmit={handleSubmit}>
              {/* <Box sx={{ position: 'relative' }}>
              </Box> */}
              {/* <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                  <CardMedia
                    component="img"
                    src="/images/tick.svg"
                    sx={{ width: '18px', float: 'right' }}
                  />
                </Box> */}
              <Grid item container xs={12} mb={1}>
                <MFTextField
                  label="PAN"
                  name="pan"
                  placeholder="Enter PAN"
                  required
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  disabled={true}
                  applyMarginBottom={false}
                  endAdornment={
                    <InputAdornment position="end">
                      <TickIcon fillColor={theme.palette.success[800]} />
                    </InputAdornment>
                  }
                />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: 'success.800', mb: 0.5 }}>
                  {ONBOARDING_KYC_VERIFIED_MESSAGE ? `KYC Verified,${' '}` : ''}
                  <Typography
                    variant="body2"
                    component={'span'}
                    sx={{
                      fontWeight: 600,
                      color: amlCheck ? 'success.800' : 'error.500',
                      mb: 0.5,
                    }}>
                    AML Check {amlCheck ? 'Passed' : 'Failed'}
                  </Typography>
                </Typography>
              </Grid>
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <Grid item xs={12}>
                  <TextDatePicker
                    label={'Date of Birth/Incorporation'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'Enter Date of Birth'}
                    name="dob"
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                    disabled={true}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <MFTextField
                  label={`${(onboardingType === 'individual' && onboardingVia === 'physical') ? 'Mobile Number' : 'Contact Person Mobile Number'}`}
                  name="mobile"
                  placeholder="Enter Mobile number"
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset>legend": {
                        fontSize: { xs: "0.6em", md: "0.81em", lg: "0.8em" }
                      }
                    }
                  }}
                  startAdornment={
                    <CountryCodesDropDown
                      ElementWidth={mobileElementWidth && mobileElementWidth}
                      name={'countryNameAndCode'}
                      value={values.countryNameAndCode}
                      // disabled={isSubmitting || isApplicationTypesLoading}
                      disabled={isSubmitting}
                    />
                  }
                  // disabled={isSubmitting || isApplicationTypesLoading}
                  disabled={isSubmitting}
                />
              </Grid>
              <Grid item xs={12}>
                <MFTextField
                  autoComplete="off"
                  label={`${(onboardingType === 'individual' && onboardingVia === 'physical') ? 'Email ID' : 'Contact Person Email ID'}`}
                  name="emailId"
                  placeholder={`${(onboardingType === 'individual' && onboardingVia === 'physical') ? 'Email ID' : 'Contact Person Email ID'}`}
                  required
                  // disabled={isSubmitting || isApplicationTypesLoading}
                  disabled={isSubmitting}
                />
              </Grid>
              {/* {isApplicationTypesLoading && (
                <Grid
                  item
                  container
                  pt={3}
                  pb={1}
                  spacing={2}
                  flexWrap={{ xs: "wrap", lg: "nowrap" }}
                >
                  {[...Array(3)].map((_, index) => (
                    <Grid
                      item
                      key={index}
                      width="100%"
                    >
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        height={45}
                        width="100%"
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
              {!isApplicationTypesLoading && (
                <Grid item xs={12} pt={3} pb={1}>
                  <UseRadioGroup
                    formLabel=""
                    name="accountType"
                    disabled={(id || isSubmitting) ? true : false}
                    items={applicationTypes.map(obj => ({
                      label: obj?.description ?? "",
                      value: obj?.code ?? "",
                      isDisabled: `${obj?.description ?? ""}`?.toLowerCase() === "advisory"
                    }))}
                  />
                </Grid>
              )} */}
              {/* {(isNonHeldAway && isPhysicalOnboarding) && (
                <Grid item xs={12} py={2}>
                  <Notes
                    displayContent={
                      'Fetch KYC Data Consent document upload is mandatory. Please upload it in the Document Upload section.'
                    }
                  />
                </Grid>
              )} */}
              <Grid item xs={12} py={2}>
                <Notes
                  displayContent={
                    // 'Based on registered email id, we will fetch the documents available with our MF holding that are serviced by kfintech and the data will be prefilled in the application.'
                    'This mobile number and email id will be used for all future communication related to this investment.'
                  }
                />
              </Grid>
              <MFSubmitButton
                //  disabled={isApplicationTypesLoading}
                loadingEnable={isSubmitting}
                label={'Proceed'}
              />
            </Grid>
          )
        }}
      </Formik>
    </>
  );
}
